<div class="app-card-general">
  <span app-badge size="lg" [color]="color">
    <ng-content></ng-content>
  </span>

  <span class="header-label">{{ data.header }}</span>
  <span class="label">{{ data.label }}</span>
</div>
